import { render } from "./page-layanan-selengkapnya.vue?vue&type=template&id=bacdf51c&scoped=true"
import script from "./page-layanan-selengkapnya.vue?vue&type=script&lang=js"
export * from "./page-layanan-selengkapnya.vue?vue&type=script&lang=js"

import "./page-layanan-selengkapnya.vue?vue&type=style&index=0&id=bacdf51c&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bacdf51c"]])

export default __exports__